import React from 'react';
import { Header, Grid, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';

import StaffWithGroup from './StaffWithGroup';
import StaffWithoutGroup from './StaffWithoutGroup';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class Staff extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            groupStaff: [],
            staff: [],
            loading: true,
        };

        this.getStaff = this.getStaff.bind(this);
    }

    componentDidMount() {
        this.getStaff();
    }

    getStaff() {
        if (localStorage.getItem('courseImplementation') !== null) {
            axios.get(`course/implementation/staff/${localStorage.getItem('courseImplementation')}`)
                .then(res => {
                    this.setState({ staff: res.data, loading: false });
                })
                .catch(err => {
                    console.log('Failed to fetch staff');
                });
            axios.get(`course/groups/staff/${this.props.location.state.courseImplementationGroupId}`)
                .then(res => {
                    this.setState({ groupStaff: res.data });
                })
                .catch(err => {
                    console.log('Failed to fetch groupStaff');
                });
        } else {
            axios.get(`course/implementation/staff/${localStorage.getItem('courseImplementationId')}`)
                .then(res => {
                    this.setState({ staff: res.data, loading: false });
                })
                .catch(err => {
                    console.log('Failed to fetch staff');
                });

            axios.get(`course/groups/staff/${this.props.location.state.courseImplementationGroupId}`)
                .then(res => {
                    this.setState({ groupStaff: res.data });
                })
                .catch(err => {
                    console.log('Failed to fetch groupStaff');
                });
        }
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;

        if (this.props.location.state.active) {
            return (
                <div>
                    <Header as="h1">Grupa: {this.props.location.state.groupName}</Header>

                    <Grid columns={2} centered className="stackable">
                        <Grid.Row stretched>
                            <Grid.Column>
                                <StaffWithoutGroup
                                    data={this.state.staff}
                                    groupStaff={this.state.groupStaff}
                                    getStaff={this.getStaff}
                                    courseImplementationGroupId={this.props.location.state.courseImplementationGroupId}
                                    examGroup={window.location.pathname === '/ispitne-grupe/studenti'}
                                    edit={localStorage.getItem('academicYearId') === localStorage.getItem('currentAcademicYearId')}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <StaffWithGroup
                                    data={this.state.groupStaff}
                                    getStaff={this.getStaff}
                                    courseImplementationGroupId={this.props.location.state.courseImplementationGroupId}
                                    edit={localStorage.getItem('academicYearId') === localStorage.getItem('currentAcademicYearId')}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                    <ToastContainer hideProgressBar />

                </div>
            );
        }

        return (
            <div>
                <Header as="h1">Nastavno osoblje</Header>
                <StaffWithGroup
                    data={this.state.groupStaff}
                    getStaff={this.getStaff}
                    courseImplementationGroupId={this.props.location.state.courseImplementationGroupId}
                    archived
                />


                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/Staff.js